import { render, staticRenderFns } from "./BriefParcel.vue?vue&type=template&id=55f9fcb6&"
import script from "./BriefParcel.vue?vue&type=script&lang=js&"
export * from "./BriefParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports